module.exports = __webpack_public_path__ + "img/Optimist.3884a7a6.svg";